<template>
	<div>
		<div class="mt-2">
			<div class="mt-3" v-if="!loading">
				<v-row v-if="listHistoryROCashback.length > 0">
					<v-col cols="12" class="d-none d-md-block">
						<v-simple-table class="white-row table-vo table-history-bonus">
							<template v-slot:default>
								<thead class="">
									<tr>
										<th class="text-left">Tanggal</th>
										<th class="text-left">Serial</th>
										<th class="text-left">Kode Mitra</th>
										<th class="text-left">Nama Mitra</th>
										<th class="text-right">Nominal</th>
									</tr>
								</thead>
								<tbody class="grey--text text--darken-3">
									<tr v-for="bonus in listHistoryROCashback" :key="bonus.sales_personal_id">
										<td>{{ bonus.sales_personal_datetime | toDayDateHour }}</td>
										<td class="text-left text-capitalize">{{ bonus.sales_personal_serial_id | emptyData }}</td>
										<td class="text-left text-capitalize">{{ bonus.sales_personal_network_code }}</td>
										<td class="text-left text-capitalize">{{ bonus.sales_personal_member_name }}</td>
										<td class="text-right green--text text-capitalize">{{ bonus.sales_personal_bonus_cashback | toRupiah}}</td>
									</tr>
								</tbody>
							</template>
						</v-simple-table>
					</v-col>

					<v-col cols="12" class="d-block d-md-none">
						<v-card elevation="1" class="mb-3 elevation-0 hover-shadow pa-3 rounded-xl" v-for="bonus in listHistoryROCashback" :key="bonus.sales_personal_id">
							<div class="d-flex align-center justify-start font-size-10 mb-4">
								<span class="d-flex align-center black--text font-weight-500"><v-icon dense class="mr-2">mdi-calendar-outline</v-icon>{{ bonus.sales_personal_datetime | toDay }}, {{ bonus.sales_personal_datetime | tanggaljam }}</span>
							</div>
							<div class="d-flex align-center justify-space-between font-size-10 mb-1">
								<span class="cl-secondary">Serial</span>
								<span class="font-weight-500">{{ bonus.sales_personal_serial_id | emptyData }}</span>
							</div>
							<div class="d-flex align-center justify-space-between font-size-10 mb-1">
								<span class="cl-secondary">Kode Mitra</span>
								<span class="font-weight-500">{{ bonus.sales_personal_network_code | toRupiah }}</span>
							</div>
							<div class="d-flex align-center justify-space-between font-size-10 mb-1">
								<span class="cl-secondary">Nama Mitra</span>
								<span class="font-weight-500">{{ bonus.sales_personal_member_name | toRupiah }}</span>
							</div>
							<div class="d-flex align-center justify-space-between font-size-11 mt-5">
								<span class="cl-secondary font-weight-600">Nominal (Rp)</span>
								<span class="green--text font-weight-600">{{ bonus.sales_personal_bonus_cashback | toRupiah }}</span>
							</div>
						</v-card>
					</v-col>
				</v-row>
				<div class="mt-3" v-if="listHistoryROCashback.length == 0">
					<v-row>
						<v-col cols="12" sm="12" md="12">
							<v-card class="py-3 elevation-0 hover-shadow rounded-xl">
								<NoData></NoData>
								<div class="pt-3 text-center primary--text">Tidak ada data riwayat komisi yang dapat ditampilkan</div>
							</v-card>
						</v-col>
					</v-row>
				</div>
				<div v-if="listHistoryROCashback.length > 0">
					<v-row justify="end">
						<v-col cols="12" sm="5" md="6" class="pl-1 pr-0 pb-1 pr-sm-3 pb-sm-3 d-flex justify-sm-start justify-end">
							<v-pagination v-model="page" total-visible="5" class="d-flex justify-end vo-pagination no-button-focus" color="primary" :length="historyROCashbackPagination.total_page" @input="changePage"></v-pagination>
						</v-col>
						<v-col cols="12" sm="5" md="5" class="pb-0 pb-sm-3 my-auto text-right">
							<div class=" font-size-10">Menampilkan {{ historyROCashbackPagination.total_display }} data dari total {{ historyROCashbackPagination.total_data }} data</div>
						</v-col>
						<v-col cols="3" sm="2" md="1">
							<v-select :items="listLimit" v-model="limit" hide-details dense class="" placeholder="Data" color="primary" item-color="red darken-3" @input="changeLimit"></v-select>
						</v-col>
					</v-row>
				</div>
			</div>
			<div class="mt-3" v-if="loading">
				<v-row>
					<v-col cols="12" sm="12" md="12">
						<LoadData :loading="loading"></LoadData>
					</v-col>
				</v-row>
			</div>
		</div>
	</div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
// import moment from 'moment'

export default {
	components: {
	},
	data() {
		return {
			loading: false,
			page: 1,
			limit: '10',
			listLimit: [ '10', '20', '50', '100' ],
			params: [],
		}
	},
	computed: {
		...mapState('komisi', ['listHistoryROCashback', 'historyROCashbackPagination']),
	},
	methods: {
		...mapActions('komisi', ['getDetailROCashback']),

		getData() {
			this.params = []
			this.loading = true

			this.getDetailROCashback(this.queryString({ sort: 'bonus_log_datetime', dir: 'DESC', page: '1', limit: '10', params: this.params })).then(() => {
				document.body.scrollTop = 0
				document.documentElement.scrollTop = 0
				this.loading = false
			})
		},
		changeDate() {
			this.params = []
			this.getData()
		},
		changePage(page) {
			this.page = page
			this.getData()
		},
		changeLimit(limit) {
			this.limit = limit
			this.page = 1
			this.getData()
		},
	},
	async created() {
		this.$store.dispatch('setPageTitle', `Riwayat Komisi Cashback`)
		this.getData()
	}
};
</script>

